<ion-header>
  <ion-toolbar>
    <ion-title>Lieferungen – {{ order.orderNumber }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <!-- Loading -->
  <div *ngIf="loading" class="loading-container">
    <ion-spinner name="crescent"></ion-spinner>
    <p>Lade Lieferungsdaten...</p>
  </div>

  <ng-container *ngIf="!loading && remainingData">

    <!-- Summary Card -->
    <div class="summary-card">
      <div class="summary-row">
        <div class="summary-item">
          <div class="summary-label">Bestellt</div>
          <div class="summary-value">{{ remainingData.summary.totalOrdered }}</div>
        </div>
        <div class="summary-item">
          <div class="summary-label">Geliefert</div>
          <div class="summary-value delivered">{{ remainingData.summary.totalDelivered }}</div>
        </div>
        <div class="summary-item">
          <div class="summary-label">Offen</div>
          <div class="summary-value remaining">{{ remainingData.summary.totalRemaining }}</div>
        </div>
        <div class="summary-item">
          <div class="summary-label">Lieferungen</div>
          <div class="summary-value">{{ remainingData.summary.deliveryCount }}</div>
        </div>
      </div>

      <div class="fully-delivered-badge" *ngIf="remainingData.summary.fullyDelivered">
        <ion-icon name="checkmark-circle-outline"></ion-icon>
        Vollständig geliefert
      </div>
    </div>

    <!-- Tab Buttons -->
    <div class="tab-buttons">
      <ion-button
        [fill]="viewMode === 'overview' ? 'solid' : 'outline'"
        (click)="switchToOverview()"
        size="small">
        Übersicht
      </ion-button>
      <ion-button
        [fill]="viewMode === 'create' ? 'solid' : 'outline'"
        (click)="switchToCreate()"
        size="small"
        [disabled]="remainingData.summary.fullyDelivered">
        Neue Lieferung
      </ion-button>
    </div>

    <!-- OVERVIEW MODE -->
    <ng-container *ngIf="viewMode === 'overview'">

      <!-- Remaining positions -->
      <div class="section-title" *ngIf="!remainingData.summary.fullyDelivered">Offene Positionen</div>
      <div class="product-list" *ngIf="!remainingData.summary.fullyDelivered">
        <ng-container *ngFor="let product of remainingData.products; trackBy: trackByModelId">
          <div class="product-card" *ngIf="product.totalRemaining && product.totalRemaining > 0">
            <div class="product-header">
              <span class="product-name">{{ product.model }} {{ product.name }}</span>
              <span class="product-color">({{ product.color }}) {{ product.colorname }}</span>
              <span class="product-remaining-badge">{{ product.totalRemaining }} offen</span>
            </div>
            <div class="size-grid">
              <div class="size-item" *ngFor="let size of product.sizes; trackBy: trackBySize">
                <ng-container *ngIf="size.orderedQuantity > 0 && size.quantity > 0">
                  <span class="size-label">{{ size.size }}</span>
                  <span class="size-detail">
                    {{ size.deliveredQuantity || 0 }}/{{ size.orderedQuantity }}
                  </span>
                  <span class="size-remaining">
                    ({{ size.quantity }} offen)
                  </span>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Existing deliveries: compact list, one row per Lieferung. Details (Produkte,
           Lexware-Historie) klappen per Klick auf — nur eine Zeile gleichzeitig offen,
           damit die Liste bei vielen Lieferungen scannbar bleibt. -->
      <div class="section-title">Bisherige Lieferungen</div>
      <div *ngIf="deliveryRows.length === 0" class="empty-state">
        Noch keine Lieferungen vorhanden.
      </div>

      <div class="delivery-list" *ngIf="deliveryRows.length > 0">
        <div class="delivery-list-header">
          <span class="col-index">Lief.</span>
          <span class="col-date">Datum</span>
          <span class="col-qty">Stück</span>
          <span class="col-amount">Betrag (brutto)</span>
          <span class="col-status">Rechnung</span>
          <span class="col-status">Lexware</span>
          <span class="col-actions"></span>
        </div>

        <div class="delivery-row-group" *ngFor="let row of deliveryRows; trackBy: trackByDeliveryRow">
          <button
            type="button"
            class="delivery-row"
            [class.expanded]="isDeliveryExpanded(row.delivery.id)"
            (click)="toggleDeliveryExpanded(row.delivery.id)">
            <span class="col-index">
              <ion-icon [name]="isDeliveryExpanded(row.delivery.id) ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon>
              {{ row.delivery.deliveryIndex }}
            </span>
            <span class="col-date">{{ row.delivery.createdAt | date:'dd.MM.yy HH:mm' }}</span>
            <span class="col-qty">{{ row.totalQty }}</span>
            <span class="col-amount">{{ row.grossPrice | currency:'EUR' }}</span>
            <span class="col-status">
              <ion-badge [color]="getInvoiceStatusColor(row.delivery.invoiceStatus)">
                {{ getInvoiceStatusLabel(row.delivery.invoiceStatus) }}
              </ion-badge>
            </span>
            <span class="col-status">
              <ion-badge [color]="rowStatusColor(row.worstLexwareStatus)">
                {{ rowStatusLabel(row.worstLexwareStatus) }}
              </ion-badge>
            </span>
            <span class="col-actions" (click)="$event.stopPropagation()">
              <ion-button size="small" fill="outline" (click)="confirmEdit(row.delivery)">
                <ion-icon name="create-outline"></ion-icon>
              </ion-button>
              <ion-button
                size="small"
                [disabled]="isSubmittingInvoice(row.delivery.id)"
                (click)="createDeliveryInvoice(row.delivery)">
                {{ isSubmittingInvoice(row.delivery.id) ? 'Wird gesendet…' : 'Rechnung' }}
              </ion-button>
            </span>
          </button>

          <div class="delivery-row-detail" *ngIf="isDeliveryExpanded(row.delivery.id)">
            <div class="delivery-products">
              <div class="delivery-product" *ngFor="let product of row.delivery.products; trackBy: trackByModelId">
                <ng-container *ngIf="hasQuantity(product)">
                  <div class="delivery-product-name">
                    {{ product.model }} {{ product.name }}
                    <span class="product-color">({{ product.color }}) {{ product.colorname }}</span>
                  </div>
                  <div class="delivery-sizes">
                    <span class="delivery-size-item" *ngFor="let size of product.sizes; trackBy: trackBySize">
                      <ng-container *ngIf="size.quantity > 0">
                        {{ size.size }}: {{ size.quantity }}
                      </ng-container>
                    </span>
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="delivery-net-price">Netto: {{ row.netPrice | currency:'EUR' }}</div>

            <!-- Lexware-Uebertragungshistorie: wann erstellt, welcher Betrag erwartet, Status,
                 und ob ein Mensch die Rechnung in Lexware tatsaechlich gesehen/bestaetigt hat. -->
            <div class="lexware-history" *ngIf="row.history.length > 0">
              <div class="lexware-history-entry" *ngFor="let entry of row.history">
                <div class="lexware-history-line">
                  <ion-badge [color]="lexwareStatusColor(entry.status)">
                    {{ lexwareStatusLabel(entry.status) }}
                  </ion-badge>
                  <span class="lexware-history-date">{{ entry.createdAt | date:'dd.MM.yyyy HH:mm' }}</span>
                  <span class="lexware-history-amount" *ngIf="entry.totalGross">
                    erwartet: {{ entry.totalGross | currency:'EUR' }}
                  </span>
                </div>

                <div class="lexware-history-line lexware-history-error-block" *ngIf="entry.status === 'failed' && (entry.errorMessageHuman || entry.errorMessage)">
                  <span class="lexware-history-error">{{ entry.errorMessageHuman || entry.errorMessage }}</span>
                </div>

                <div class="lexware-history-line" *ngIf="entry.status === 'done'">
                  <ion-badge [color]="entry.lexwareConfirmedAt ? 'success' : 'medium'">
                    {{ entry.lexwareConfirmedAt ? 'In Lexware bestätigt' : 'Unbestätigt' }}
                  </ion-badge>
                  <span class="lexware-history-confirmed-meta" *ngIf="entry.lexwareConfirmedAt">
                    {{ entry.lexwareConfirmedBy }}, {{ entry.lexwareConfirmedAt | date:'dd.MM.yyyy HH:mm' }}
                  </span>
                  <ion-button
                    *ngIf="!entry.lexwareConfirmedAt"
                    size="small"
                    fill="clear"
                    (click)="confirmLexwareEntry(row.delivery.id, entry)">
                    In Lexware gesehen — bestätigen
                  </ion-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </ng-container>

    <!-- EDIT MODE -->
    <ng-container *ngIf="viewMode === 'edit'">

      <div class="create-header">
        <div class="section-title">Lieferung {{ editingDelivery?.deliveryIndex }} bearbeiten</div>
        <div class="create-actions">
          <ion-button size="small" fill="outline" color="medium" (click)="resetAll()">
            Zurücksetzen
          </ion-button>
          <ion-button size="small" fill="outline" (click)="setAllRemaining()">
            Alle Restmengen
          </ion-button>
        </div>
      </div>

      <div class="product-list">
        <ng-container *ngFor="let product of deliveryProducts; trackBy: trackByModelId">
          <div class="product-card" *ngIf="product.totalRemaining > 0">
            <div class="product-header">
              <span class="product-name">{{ product.model }} {{ product.name }}</span>
              <span class="product-color">({{ product.color }}) {{ product.colorname }}</span>
              <span class="product-qty-badge" *ngIf="getProductDeliveryQty(product) > 0">
                {{ getProductDeliveryQty(product) }} ausgewählt
              </span>
            </div>

            <div class="size-edit-grid">
              <div class="size-edit-item" *ngFor="let size of product.sizes; trackBy: trackBySize">
                <ng-container *ngIf="size.maxQty > 0">
                  <div class="size-edit-label">
                    <span class="size-name">{{ size.size }}</span>
                    <span class="size-max">max {{ size.maxQty }}</span>
                  </div>
                  <div class="size-edit-controls">
                    <ion-button fill="clear" size="small" (click)="decrementQty(size)" [disabled]="size.deliveryQty <= 0">
                      <ion-icon name="remove-outline"></ion-icon>
                    </ion-button>
                    <ion-input
                      type="number"
                      class="qty-input"
                      [ngModel]="size.deliveryQty"
                      (ionBlur)="updateQty(size, $event.target.value)"
                      [min]="0"
                      [max]="size.maxQty">
                    </ion-input>
                    <ion-button fill="clear" size="small" (click)="incrementQty(size)" [disabled]="size.deliveryQty >= size.maxQty">
                      <ion-icon name="add-outline"></ion-icon>
                    </ion-button>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="submit-bar">
        <div class="submit-info">
          <strong>{{ getTotalDeliveryQty() }}</strong> Stück ausgewählt
        </div>
        <div class="submit-actions">
          <ion-button fill="outline" color="medium" (click)="switchToOverview()">
            Abbrechen
          </ion-button>
          <ion-button
            fill="solid"
            color="primary"
            (click)="updateDelivery()"
            [disabled]="!hasDeliveryItems()">
            Änderungen speichern
          </ion-button>
        </div>
      </div>

    </ng-container>

    <!-- CREATE MODE -->
    <ng-container *ngIf="viewMode === 'create'">

      <div class="create-header">
        <div class="section-title">Neue Teillieferung erstellen</div>
        <div class="create-actions">
          <ion-button size="small" fill="outline" color="medium" (click)="resetAll()">
            Zurücksetzen
          </ion-button>
          <ion-button size="small" fill="outline" (click)="setAllRemaining()">
            Alle Restmengen
          </ion-button>
        </div>
      </div>

      <div class="product-list">
        <ng-container *ngFor="let product of deliveryProducts; trackBy: trackByModelId">
          <div class="product-card" *ngIf="product.totalRemaining > 0">
            <div class="product-header">
              <span class="product-name">{{ product.model }} {{ product.name }}</span>
              <span class="product-color">({{ product.color }}) {{ product.colorname }}</span>
              <span class="product-qty-badge" *ngIf="getProductDeliveryQty(product) > 0">
                {{ getProductDeliveryQty(product) }} ausgewählt
              </span>
            </div>

            <div class="size-edit-grid">
              <div class="size-edit-item" *ngFor="let size of product.sizes; trackBy: trackBySize">
                <ng-container *ngIf="size.maxQty > 0">
                  <div class="size-edit-label">
                    <span class="size-name">{{ size.size }}</span>
                    <span class="size-max">max {{ size.maxQty }}</span>
                  </div>
                  <div class="size-edit-controls">
                    <ion-button fill="clear" size="small" (click)="decrementQty(size)" [disabled]="size.deliveryQty <= 0">
                      <ion-icon name="remove-outline"></ion-icon>
                    </ion-button>
                    <ion-input
                      type="number"
                      class="qty-input"
                      [ngModel]="size.deliveryQty"
                      (ionBlur)="updateQty(size, $event.target.value)"
                      [min]="0"
                      [max]="size.maxQty">
                    </ion-input>
                    <ion-button fill="clear" size="small" (click)="incrementQty(size)" [disabled]="size.deliveryQty >= size.maxQty">
                      <ion-icon name="add-outline"></ion-icon>
                    </ion-button>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="submit-bar">
        <div class="submit-info">
          <strong>{{ getTotalDeliveryQty() }}</strong> Stück ausgewählt
        </div>
        <div class="submit-actions">
          <ion-button fill="outline" color="medium" (click)="switchToOverview()">
            Abbrechen
          </ion-button>
          <ion-button
            fill="solid"
            color="primary"
            (click)="submitDelivery()"
            [disabled]="!hasDeliveryItems()">
            Lieferung erstellen
          </ion-button>
        </div>
      </div>

    </ng-container>

  </ng-container>

</ion-content>
